export default "/images/logo-4.png?7c175524fd737794dccc579260d16d8a";